module.exports = __webpack_public_path__ + "static/media/theme_1.98c331de.jpg";